import React from 'react'
import { useSelector } from 'react-redux';
import SearchResultComponentSimple from './SearchResultComponentSimple';
import SearchResultComponentMasive from './SearchResultComponentMasive';

export default function InboxSearch() {
  const StateWorFlow = useSelector((state) => state?.Authentication?.items?.WorkFlowData?.WorkFlowName);
  const StateWor = useSelector((state) => state);
  let workFlowDataSesion = sessionStorage.getItem('WorkFlowData')

  const productosAplication = ['Contratación Argentina',
    'Contratación Colombia Masivo',
    'Contratación Colombia Estándar',
    'Contratación ML Chile Masivo',
    'Contratación ML Chile Estándar',
    'Contratação no Brasil'
  ];

  console.log('REDUX', StateWor, StateWorFlow, productosAplication.includes(StateWorFlow),  productosAplication.includes(workFlowDataSesion))
  if (productosAplication.includes(StateWorFlow) || productosAplication.includes(workFlowDataSesion)) {
    return (
      <SearchResultComponentMasive />
    )
  } else {
    return (
      <SearchResultComponentSimple />
    )
  }
}
